import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Anguilla: Country = {
    identifier: "Anguilla",
    name: "Anguilla",
    countryCode: "AI",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇦🇮",
    svgPath: "m 298.08375,411.2344 -0.446,0.148 0.018,-0.085 0.358,-0.203 0.13,0.014 z",
}
